<template>
  <div class="py-5 md:px-5">
    <PageHeader 
      class="max-w-4xl" 
      :title="`${$route.params.id ? 'Edit' : 'Create'} Customer`" 
      :back-route="$route.params.id ? { name: 'CustomerView', params: { id: $route.params.id } } : { name: 'CustomerList' }" />
    
    <div class="max-w-4xl mx-auto">
      <div class="p-6 card">
        <Loading v-if="$route.params.id && loading" />
        <form @submit.prevent="upsertCustomer()" v-else>
          <div class="px-4 py-2 mb-3 text-red-700 bg-red-200 rounded-md" v-if="form_errors.length">
            <div v-for="error in form_errors" :key="error.message">
              {{ error.message }}
            </div>
          </div>
          <fieldset class="form-group">
            <label for="" class="form-label">
              Name
            </label>
            <input type="text" class="form-input" v-model="form.name">
            <validations field="name" :errors="errors" />
          </fieldset>
          <fieldset class="form-group">
            <label for="" class="form-label">
              Company
            </label>
            <input type="text" class="form-input" v-model="form.company">
            <validations field="company" :errors="errors" />
          </fieldset>
          <fieldset class="form-group">
            <label for="" class="form-label">
              Email
            </label>
            <input type="text" class="form-input" v-model="form.email">
            <validations field="email" :errors="errors" />
          </fieldset>
          <fieldset class="form-group">
            <label for="" class="form-label">
              Phone
            </label>
            <CellphoneInput :value="form.customer_phone" @input="handlePhoneInput" @load="phoneInputLoaded" />
            <validations field="phone" :errors="errors" />
          </fieldset>

          <button class="mt-4 btn btn-primary" v-submitting="submitting">
            {{ $route.params.id ? 'Save' : 'Create' }} Customer
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AddressAutocomplete from '@/components/AddressAutocomplete'
import CellphoneInput from '@/components/CellphoneInput'

export default {
  name: 'CustomerForm',

  components: {
    AddressAutocomplete,
    CellphoneInput
  },

  created () {
    if (this.$route.params.id) {
      this.getCustomer()
    }
  },

  computed: {
    ...mapGetters(['account'])
  },

  data () {
    return {
      loading: true,
      submitting: false,
      form_errors: [],
      errors: [],
      form: {
        name: '',
        company: '',
        email: '',
        phone: '',
        country: ''
      }
    }
  },

  methods: {
    phoneInputLoaded (data) {
      this.form.country = data.activeCountry.iso2
    },

    handlePhoneInput (number, country) {
      this.form.phone = number
      this.form.country = country.iso2
    },

    async getCustomer () {
      try {
        const { data } = await this.$api.get(`/account/${this.$route.params.account}/customers/${this.$route.params.id}`)
        this.form = data.customer
        this.loading = false
      } catch (error) {
        this.$toasted.error('There was a problem fetching this customer.')
        console.error(error)
      }
    },

    async upsertCustomer () {
      try {
        this.submitting = true
        if (this.$route.params.id) {
          await this.$api.patch(`/account/${this.$route.params.account}/customers/${this.$route.params.id}`, this.form)
        } else {
          await this.$api.post(`/account/${this.$route.params.account}/customers/`, this.form)
        }
        this.$toasted.show(`Customer "${this.form.name}" ${this.$route.params.id ? 'Updated' : 'Created'}`)
        this.$router.push({ name: 'CustomerList' })
      } catch (error) {
        this.errors = error.response.data.errors ? error.response.data.errors : []
        this.form_errors = error.response.data.form_errors ? error.response.data.form_errors : []
        this.$toasted.error('There was a problem saving this customer.')
        console.error(error)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
